import { useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "ui/components/tabs";
import { Icon } from "components";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "ui/components/tooltip";
import {
    AWARD,
    BADGE,
    BILLABLE,
    JOB,
    MILESTONE,
    PROJECT,
    REWARD,
    SUPPORT,
} from "icons";

export default function CollectionFilters({ filters, setFilters }) {
    const [selectedCollection, setSelectedCollection] = useState("all");

    const collectionIcons = {
        projects: PROJECT,
        jobs: JOB,
        milestones: MILESTONE,
        billables: BILLABLE,
        tickets: SUPPORT,
        awards: AWARD,
        badges: BADGE,
        rewards: REWARD,
    };

    const collectionNavItems = [
        { id: "all", label: "All" },
        ...Object.entries(collectionIcons).map(([key, icon]) => ({
            id: key,
            label: key.charAt(0).toUpperCase() + key.slice(1),
            icon,
        })),
    ];

    return (
        <Tabs
            value={selectedCollection}
            onValueChange={(value) => {
                setSelectedCollection(value);

                if (value === "all") {
                    setFilters({ ...filters, collection: undefined });
                } else if (value === "jobs") {
                    setFilters({ ...filters, collection: { _in: ["jobs", "job_extensions"] } });
                } else {
                    setFilters({ ...filters, collection: { _eq: value } });
                }
            }}
        >
            <TabsList className="bg-muted">
                {collectionNavItems.map((item) => (
                    <TabsTrigger
                        key={item.id}
                        value={item.id}
                        className="cursor-pointer flex items-center gap-2"
                    >
                        <TooltipProvider>
                            <Tooltip>
                                <TooltipTrigger>
                                    {item.id === "all" ? item.label : item.icon && <Icon icon={item.icon} className="size-4" />}
                                </TooltipTrigger>
                                <TooltipContent>
                                    {item.label}
                                </TooltipContent>
                            </Tooltip>
                        </TooltipProvider>
                    </TabsTrigger>
                ))}
            </TabsList>
        </Tabs>
    );
}
